import AbilityPointPieChart from '../../primary_admin/components/AbilityPointPieChart';

export default function AbilityPointsRight() {
    return (
        <div className='w-full h-full flex'>
            <div className='flex-1 flex flex-col bg-[white] rounded-[10px] p-[16px] w-full  overflow-auto'>
                    <div className='w-full pb-[4px] font-bold'>各能力點成績</div>
                    <div className='w-full flex flex-row items-start justify-start flex-wrap gap-[16px] rounded-[10px] p-[6px] text-[black]'>
                        {[
                            {count:10,total:30,label:'1.1 獲取並提取文本內信息'},
                            {count:10,total:40,label:'1.2 跨來源搜索、導航與篩選'},
                            {count:10,total:50,label:'2.1 建構文本字面意義'},
                            {count:10,total:60,label:'2.2 生成推斷'},
                            {count:10,total:70,label:'2.3 整合文本內信息'},
                            {count:10,total:60,label:'2.4 整合跨文本信息'},
                            {count:10,total:60,label:'3.1 評估質量與真實性'},
                            {count:10,total:60,label:'3.2 反思內容與形式'},
                            {count:10,total:50,label:'3.3 發現並處理衝突'},
                            {count:10,total:40,label:'4.1 將理解遷移至新情境'},
                            {count:10,total:40,label:'4.2 創造並傳達新意義'}
                        ].map((item,index)=>
                            <div key={index} className='p-[24px] flex flex-col items-center justify-center max-w-[200px]'>
                                <div className='font-bold h-[60px]'>{item.label}</div>
                                <AbilityPointPieChart data={item}/>
                            </div>
                        )}
                    </div>
                </div>
        </div>
    );
}
